import React, { useEffect, useRef, useState } from 'react';
import { FiArrowUpRight, FiCopy, FiStar } from 'react-icons/fi';
import { motionReviewApi, readableError } from './api';

export default function MotionSightingActions({ taskId, api = motionReviewApi }) {
  const [sighting, setSighting] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const [retry, setRetry] = useState(0);
  const busy = useRef(false);
  useEffect(() => {
    let active = true;
    setLoading(true); setError(''); setSighting(null);
    Promise.resolve().then(() => api.sighting({ taskId, action: 'lookup' })).then((result) => {
      if (active) setSighting(result);
    }).catch((requestError) => { if (active) setError(readableError(requestError)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [api, taskId, retry]);
  const href = sighting?.sightingId ? `/sightings?sighting=${encodeURIComponent(sighting.sightingId)}` : null;
  const highlight = async () => {
    if (busy.current) return;
    busy.current = true; setSaving(true); setError('');
    try {
      setSighting(await api.sighting({ taskId, action: 'highlight', allowPreview: !sighting?.sightingId }));
    } catch (requestError) { setError(readableError(requestError)); }
    finally { busy.current = false; setSaving(false); }
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(new URL(href, window.location.origin).href); setCopied(true); }
    catch (_) { setError('Couldn’t copy the link. You can open the sighting and copy its address.'); }
  };
  return <section className="cr-staff-sighting" aria-label="Lodge highlight">
    <strong>Lodge highlight</strong>
    {loading ? <p className="cr-small cr-muted" role="status">Finding the original sighting…</p> : <>
      {sighting && <p className="cr-small cr-muted">{!href ? 'No original recording is linked. Highlighting will publish this short motion preview to the lodge’s Highlights.' : sighting.isMotionPreview ? 'This sighting uses the short motion preview.' : 'Uses the original recording in Ting Vision.'}</p>}
      <div className="cr-staff-sighting-actions">
        {sighting && <button type="button" className="cr-primary" disabled={saving || sighting.isHighlighted} onClick={highlight}>
          <FiStar aria-hidden="true" /> {saving ? 'Highlighting…' : sighting.isHighlighted ? 'Highlighted for lodge' : href ? 'Highlight for lodge' : 'Highlight motion preview'}
        </button>}
        {href && <><a className="cr-button cr-button-secondary" href={href} target="_blank" rel="noopener noreferrer">Open sighting <FiArrowUpRight aria-hidden="true" /></a>
          <button type="button" className="cr-button cr-button-secondary" onClick={copy}><FiCopy aria-hidden="true" />{copied ? 'Link copied' : 'Copy sighting link'}</button></>}
      </div>
      {error && <p className="cr-error" role="alert">{error} {!sighting && <button type="button" className="cr-text-button" onClick={() => setRetry((value) => value + 1)}>Retry</button>}</p>}
    </>}
  </section>;
}
